"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = load;
var head = document.head || document.getElementsByTagName('head')[0];
var scriptStateMap = {};

function load(path, callback, options) {
  var el = document.createElement('script');
  if ((options === null || options === void 0 ? void 0 : options.crossOrigin) !== undefined) el.crossOrigin = options.crossOrigin;
  var loaded;

  function handler(event) {
    if (el.readyState && !/^c|loade/.test(el.readyState) || loaded) return;
    el.onload = el.onerror = el.onreadystatechange = null;
    loaded = true;
    scriptStateMap[path] = 2;
    callback(event);
  }

  el.onload = el.onerror = el.onreadystatechange = handler;
  el.async = true;
  el.src = path;
  head.insertBefore(el, head.lastChild);
}
//# sourceMappingURL=scriptLoader.js.map